

import React, { useEffect, useState } from 'react';
import {
  Fuel,
  ThumbsUp,
  ThumbsDown,
  Droplets,
  Download,
  ArrowUp,
  ArrowDown,
  Minus
} from 'lucide-react';
import styles from './GrowthTrackingTab.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN, INIT_FILTER_STATE_MILEAGE_SAARATHI } from '../../../../constants/driveglobalfilterinitalstates_bus';
import DownloadReport from './Downloadreport';
import { decodeToken } from 'react-jwt';

const KPICards = ({ filterdata }) => {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE_MILEAGE_SAARATHI, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE_MILEAGE_SAARATHI
  const [globalFilter, setGlobalFilter] = useState({ ...sampleObj })
  const { sendReq: fetchData } = useHttp();

  const [kpiData, setKpiData] = useState([
    {
      icon: <Fuel className={styles.paramIcon} />,
      value: '0 / 5',
      label: 'Energy Efficiency Score',
      trend: 'neutral'
    },
    {
      icon: <ThumbsUp className={styles.paramIcon} />,
      value: '0',
      label: 'Vehicle Improved',
      trend: 'neutral'
    },
    {
      icon: <ThumbsDown className={styles.paramIcon} />,
      value: '0',
      label: 'Vehicle Not Improved',
      trend: 'neutral'
    },
    {
      custom: true,
      left: {
        icon: <Droplets className={styles.paramIcon} />,
        // value: '0 L / 0 Kg',
        value: '0',
        label: 'Net Energy Saved',
        trend: 'neutral'
      },
      rightTop: {
        value: '₹ 0',
        label: 'Amount Spent',
        trend: 'neutral'
      },
      rightBottom: {
        value: '₹ 0',
        label: 'Amount Saved',
        trend: 'neutral'
      }
    }
  ]);

  const renderTrendArrow = (trend) => {
    switch (trend) {
      case 'up':
        return <ArrowUp className="text-success" style={{ width: '16px', height: '16px' }} />;
      case 'down':
        return <ArrowDown className="text-danger" style={{ width: '16px', height: '16px' }} />;
      case 'neutral':
        return <Minus className="text-secondary" style={{ width: '16px', height: '16px' }} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const requestBody = { filterdata };

    // Fetch improved / not improved data
    fetchData(
      {
        url: API_URL_MAIN + 'growth_tracking/growth_tracking_improved_notimproved',
        body: requestBody
      },
      (result) => {
        if (result && Array.isArray(result) && result.length) {
          const latestEntry = result.reduce((latest, current) => {
            return current.month > latest.month ? current : latest;
          }, result[0]);

          setKpiData(prev => {
            const updated = [...prev];
            updated[1] = {
              ...updated[1],
              value: latestEntry.improved_vehicle_count || '0',
              trend: 'up'
            };
            updated[2] = {
              ...updated[2],
              value: latestEntry.not_improved_vehicle_count || '0',
              trend: 'down'
            };
            return updated;
          });
        }
      }
    );

    fetchData(
      {
        url: API_URL_MAIN + 'growth_tracking/amount_spent',
        body: requestBody
      },
      (res) => {
        if (res) {
          setKpiData(prev => {
            const updated = [...prev];
            updated[3] = {
              ...updated[3],
              rightTop: {
                ...updated[3].rightTop,
                value: res.amount_spent
                  ? Number(res.amount_spent)?.toFixed(2)
                  : 0,// ₹'
                trend: 'up'
              }
            };
            return updated;
          });
        }
      }
    );

    // Energy Saved → update left of last card
    fetchData(
      {
        url: API_URL_MAIN + 'growth_tracking/energy_saved',
        body: requestBody
      },
      (res) => {
        if (res) {
          setKpiData(prev => {
            const updated = [...prev];
            updated[3] = {
              ...updated[3],
              left: {
                ...updated[3].left,
                value: res.energy_saved
                  ? `${Number(res.energy_saved).toFixed(2)} `
                  : '0',
                trend: 'up'
              }
            };
            return updated;
          });
        }
      }
    );

    // Amount Saved → update rightBottom of last card
    fetchData(
      {
        url: API_URL_MAIN + 'growth_tracking/amount_saved',
        body: requestBody
      },
      (res) => {
        if (res) {
          setKpiData(prev => {
            const updated = [...prev];
            updated[3] = {
              ...updated[3],
              rightBottom: {
                ...updated[3].rightBottom,
                value: res.amount_saved
                  ? Number(res.amount_saved).toFixed(2)
                  : 0,
                trend: 'up'
              }
            };
            return updated;
          });
        }
      }
    );

    // Fetch energy efficiency KPI data
    fetchData(
      {
        url: API_URL_MAIN + 'growth_tracking/energy_efficiency_score',
        body: requestBody
      },
      (efficiencyResult) => {
        if (efficiencyResult) {
          setKpiData(prev => {
            const updated = [...prev];
            updated[0] = {
              ...updated[0],
              value: efficiencyResult.energyEfficiencyScore
                ? `${Number(efficiencyResult.energyEfficiencyScore).toFixed(2)} / 5`
                : '0.00 / 5',
              trend: 'up'
            };
            return updated;
          });
        }
      }
    );
  }, [filterdata]);

  function formatToK(num) {
    // null / undefined / non-number handle
    if (num == null || isNaN(num)) return "0k ₹";

    num = Number(num); // ensure number

    if (num < 1000) {
      return Math?.floor((num / 1000)?.toFixed(1)) + "k ₹";
    }
    return Math?.floor(num / 1000) + "k ₹";
  }


  return (
    <div className={styles.dashboardContainer}>
      <div className="container-fluid px-4 py-3">
        <div className="row align-items-center">
          <div className="col text-end">
            {/* <a
    href="#"
    className={`${styles.downloadBtn} text-decoration-none`}
    onClick={(e) => {
      e.preventDefault();
      if (downloadReport) downloadReport();
    }}
  >
    <Download className="me-1" size={16} />
    Download Report
  </a> */}
            <DownloadReport filterdata={globalFilter} setGloablfilter={setGlobalFilter} />


          </div>
        </div>
      </div>

      <div className="container-fluid px-4">
        <div className="row g-3">
          {kpiData.map((kpi, index) => (
            <div key={index} className="col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex">
              <div className="card w-100">
                <div className="card-body py-3 px-3 d-flex flex-column justify-content-between">
                  {!kpi.custom ? (
                    // existing code for normal cards
                    <div className="d-flex align-items-start justify-content-between">
                      <div className="d-flex align-items-start flex-grow-1">
                        <div className="flex-shrink-0 me-2">
                          {React.cloneElement(kpi.icon, {
                            size: index < 3 ? 32 : 20
                          })}
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                          <div className="fw-bold mb-1 fs-6">{kpi.value}</div>
                          <div className={styles.kpilabel}>{kpi.label}</div>
                        </div>
                      </div>
                      <div className="flex-shrink-0 ms-1">{renderTrendArrow(kpi.trend)}</div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex align-items-start me-3">
                        <div className="flex-shrink-0 me-2">
                          {React.cloneElement(kpi.left.icon, {
                            size: index < 3 ? 32 : 20
                          })}
                        </div>
                        <div>
                          {/* 👇 check if it's the last card (index === 3) and render differently */}
                          <div className="fw-bold mb-1 fs-6">
                            {index === 3
                              ? `${Math.ceil(kpi?.left?.value)} kWh`
                              : kpi.left?.value}
                          </div>
                          <div className="fw-medium">{kpi.left.label}</div>
                        </div>
                      </div>

                      <div className="d-flex flex-column text-end ms-auto">
                        <div className="mb-2">
                          <div className="fw-bold fs-6">{formatToK(kpi?.rightTop?.value)}</div>
                          <div className="fw-medium">{kpi.rightTop.label}</div>
                        </div>
                        <div>
                          <div className="fw-bold fs-6">{formatToK(kpi?.rightBottom?.value)}</div>
                          <div className="fw-medium">{kpi.rightBottom.label}</div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="row mt-3 mb-4">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <small className={styles.carbonInfo}>Data is shown for current month only</small>
              <small className={styles.carbonInfo}>
                Carbon Footprint Reduced till date 1.4 MT (These values captured since start date)
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPICards;

